import React, { useState, useEffect, useCallback } from 'react';
import AgencyIndexComponent from './Index.component';
import { getAgencyList } from 'api/student/v2/agency.api';
import { IAgencyList } from 'api/interfaces/app.interface';

const AgencyIndexContainer: React.FC = () => {
    const [agencyList, setAgencyList] = useState<IAgencyList[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);

    // 첫 페이지 데이터 로드
    const fetchInitialData = useCallback(async () => {
        try {
            setIsLoading(true);
            const result = await getAgencyList(1);
            
            if (result?.agencyList) {
                setAgencyList(result.agencyList);
                setHasMore(result.pagination?.hasNextPage || false);
                setCurrentPage(1);
            } else {
                setAgencyList([]);
                setHasMore(false);
            }
        } catch (error) {
            console.error('기획사 목록 조회 실패:', error);
            setAgencyList([]);
            setHasMore(false);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // 추가 데이터 로드
    const handleLoadMore = useCallback(async () => {
        if (isLoadingMore || !hasMore) return;

        try {
            setIsLoadingMore(true);
            const nextPage = currentPage + 1;
            const result = await getAgencyList(nextPage);
            
            if (result?.agencyList && result.agencyList.length > 0) {
                setAgencyList(prev => [...prev, ...result.agencyList]);
                setHasMore(result.pagination?.hasNextPage || false);
                setCurrentPage(nextPage);
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error('추가 데이터 로드 실패:', error);
            setHasMore(false);
        } finally {
            setIsLoadingMore(false);
        }
    }, [currentPage, hasMore, isLoadingMore]);

    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    return (
        <AgencyIndexComponent
            agencyList={agencyList}
            isLoading={isLoading}
            isLoadingMore={isLoadingMore}
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
        />
    );
};

export default AgencyIndexContainer;

